import ModelBase from "./shared/model-base.js";

interface ModelAttributes {
  id: string | number;
  notification_id?: number | string;
  title?: string;
  body?: string;
  url?: string;
  icon?: string;
  read_at?: string | null;
  dismissed_at?: string | null;
  created_at?: string;
  updated_at?: string;
}

const OPTIONS = {
  i18nModelName: "inmail",
  columns: [
    "id",
    "notification_id",
    "title",
    "body",
    "url",
    "icon",
    "read_at",
    "dismissed_at",
    "created_at",
    "updated_at",
  ],
  editColumns: {},
};

export default class Inmail extends ModelBase {
  constructor(attributes: Partial<ModelAttributes> = {}) {
    super(OPTIONS, attributes);
  }

  get isUnread(): boolean {
    return !this.read_at;
  }
}
